import { useEffect, useState, useContext, createContext, useMemo } from 'react';
import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import { useRecoilState, useRecoilValue } from 'recoil';
import debounce from 'lodash/debounce';
import atoms from '@Components/Utilities/SandhillsAtoms';

const WindowSizeContext = createContext({});
let windowSizeIsUpdating = false;

const WindowSizeProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useRecoilState(atoms.currentUser);
    const routes = useRecoilValue(atoms.routes);

    const [windowSize, setWindowSize] = useState({
        width: currentUser.ScreenSize.Width,
        height: currentUser.ScreenSize.Height,
        isMobile: currentUser.ScreenSize.IsMobile,
        isNotMobile: currentUser.ScreenSize.IsNotMobile
    });

    useEffect(() => {
        const handleResize = () => {
            var width = window.innerWidth;
            var height = window.innerHeight;
            var isMobile = width <= currentUser.ScreenSize.MobileBreakpoint;
            var isNotMobile = width >= currentUser.ScreenSize.NotMobileBreakpoint;

            if (width != windowSize.width || height != windowSize.height || isMobile != windowSize.isMobile || isNotMobile != windowSize.isNotMobile) {
                setWindowSize({
                    width: width,
                    height: height,
                    isMobile: isMobile,
                    isNotMobile: isNotMobile,
                });
            }

            var diffThreshold = 150;
            var widthDiff = Math.abs(currentUser.ScreenSize.Width - width);
            var heightDiff = Math.abs(currentUser.ScreenSize.Height - height);

            if (!windowSizeIsUpdating && (widthDiff > diffThreshold || heightDiff > diffThreshold || currentUser.ScreenSize.IsMobile != isMobile)) {
                windowSizeIsUpdating = true;

                saveUserSettingsCookie({ width: width, height: height, url: routes.SaveUserSettings })
                    .then(data => {
                        setCurrentUser(prevState => ({ ...prevState, ScreenSize: data.screenSize }));
                        windowSizeIsUpdating = false;
                    })
                    .catch(error => {
                        console.log('Error saving UserSettings cookie: ', error);
                        windowSizeIsUpdating = false;
                    });
            }
        };

        const debouceResize = debounce(handleResize, 500);

        handleResize();
        window.addEventListener('resize', debouceResize);
        return () => window.removeEventListener('resize', debouceResize);
        // Need to use specific props for the dependency and not the whole currentUser object because it changes constantly
    }, [currentUser.ScreenSize.Width, currentUser.ScreenSize.Height]);

    return (
        <WindowSizeContext.Provider value={windowSize}>
            {children}
        </WindowSizeContext.Provider>
    );
};
const WindowSizeConsumer = WindowSizeContext.Consumer;

/* This hook returns the viewport/window height and width */
const useWindowSize = () => {
    const windowSize = useContext(WindowSizeContext);

    return windowSize;
};

export {
    useWindowSize,
    WindowSizeProvider,
    WindowSizeConsumer
};